import { API_TTask } from "@/models/tasks";

export type TEmployee = {
  count: TEmployee_Count;
  employee_list: TEmployee_List[];
};

export type TEmployee_Count = {
  active_count: number;
  terminated_count: number;
};

export type TEmployee_List = {
  first_name: string;
  id: number;
  immigration_category: string;
  job_title: string;
  last_name: string;
  status: string;
  type: string;
  user_id: number;
  visa_expiration: string;
  working_status: string;
  email: string;
};

export type TEmployeeSummary = {
  compliance: string;
  email: string;
  employee_first_name: string;
  employee_last_name: string;
  employee_title: string;
  employment_type: string;
  job_title: string;
  reason_of_termination: string;
  visa_category: string;
  visa_end_date: string;
  visa_start_date: string;
  work_end_date: string;
  work_start_date: string;
  working_status: string;
  tasks: API_TTask[];
  employer_tasks: API_TTask[];
};

export type TEmployeePayload = {
  leaving_date: string;
};

export type TEmployee_Table = {
  id: number;
  name: string;
  // TODO: remove jobTitle and job_title for src/modules/Employees/Browse/VEmployeesBrowseOld.vue
  job_title: string;
  jobTitle: string;
  job_position: string;
  employeeType: string;
  immigrationCategory: string;
  visaExpiration: string;
  status: string;
  userId: number;
  workingStatus: string;
  badgeType: string;
  email: string;
};

const STATUS_COMPLIANT = "compliant";
const STATUS_NOT_COMPLIANT = "not_compliant";
const LABEL_COMPLIANT = "Compliant";
const LABEL_NOT_COMPLIANT = "Not Compliant";

export const convertStatus = (status: string): string => {
  if (status === STATUS_COMPLIANT) return LABEL_COMPLIANT;

  if (status === STATUS_NOT_COMPLIANT) return LABEL_NOT_COMPLIANT;

  return "―";
};

export const convertBadgeType = (status: string): string => {
  if (status === STATUS_COMPLIANT) return "DarkLimeGreen200";

  if (status === STATUS_NOT_COMPLIANT) return "RaspberryPink400";

  return "DarkLimeGreen200";
};

export const convertEmployeesForTable = (a: TEmployee_List): TEmployee_Table => {
  return {
    id: a.id,
    name: a.first_name && a.last_name ? `${a.first_name} ${a.last_name}` : "―",
    job_title: a.job_title ? a.job_title : "―",
    jobTitle: a.job_title ? a.job_title : "―",
    job_position: a.job_title ? a.job_title : "―",
    employeeType: a.type ? a.type : "―",
    immigrationCategory: a.immigration_category ? a.immigration_category : "―",
    visaExpiration: a.visa_expiration ? a.visa_expiration : "―",
    userId: a.user_id,
    workingStatus: a.working_status,
    status: convertStatus(a.status),
    badgeType: convertBadgeType(a.status),
    email: a.email,
  };
};

export const sortEmployeesData = (items) => {
  const itemsGroupedByStatus = items.reduce((acc, cur) => {
    if (!Object.prototype.hasOwnProperty.call(acc, cur.status)) {
      Object.assign(acc, {
        [cur.status]: [],
      });
    }

    acc[cur.status].push(cur);

    return acc;
  }, {});

  const prependGroup = [];
  const appendGroup = [];

  Object.keys(itemsGroupedByStatus).forEach((status) => {
    if (status === LABEL_NOT_COMPLIANT) {
      prependGroup.push(...itemsGroupedByStatus[status]);
    } else {
      appendGroup.push(...itemsGroupedByStatus[status]);
    }
  });

  prependGroup.sort((a, b) => (a.name > b.name ? 1 : -1));
  appendGroup.sort((a, b) => (a.name > b.name ? 1 : -1));

  return [...prependGroup, ...appendGroup];
};
